import { render, staticRenderFns } from "./CustomizeContentBlockModal.vue?vue&type=template&id=46c3db1e&lang=pug&"
import script from "./CustomizeContentBlockModal.vue?vue&type=script&lang=js&"
export * from "./CustomizeContentBlockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports